import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  summaryData: null,
  companyCount: 0,
};

const companyCatalogListingSlice = createSlice({
  name: "companyCatalogListing",
  initialState,
  reducers: {
    fetchCompanyCatalogSummary(state, action) {
      state.loading = true;
    },
    fetchCompanyCatalogSummarySuccess(state, action) {
      state.summaryData = action.payload.data.document;
      state.companyCount = action.payload.count;
      state.loading = false;
    },
    fetchCompanyCatalogSummaryFailure(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = companyCatalogListingSlice;
